export var TrezorDerivationPathType;
(function (TrezorDerivationPathType) {
    TrezorDerivationPathType["Bip32"] = "bip32";
    TrezorDerivationPathType["Bip44"] = "bip44";
    TrezorDerivationPathType["Legacy"] = "legacy";
})(TrezorDerivationPathType || (TrezorDerivationPathType = {}));
